"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
var player_config_1 = require("../typings/player-config");
var utilities_1 = require("../utilities");
var replaceContentfulUrl_1 = __importDefault(require("../utilities/replaceContentfulUrl"));
var Logo = (function () {
    function Logo(clientConfig, apiLogo) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.file = '';
        this.hide = false;
        this.link = '';
        this.linkType = null;
        this.margin = 0;
        this.width = 75;
        this.position = '';
        this.altText = 'KIJK';
        this.style = '';
        this.classList = '';
        if (!clientConfig.logo && !apiLogo)
            return;
        this.file = (0, replaceContentfulUrl_1.default)(((_a = clientConfig.logo) === null || _a === void 0 ? void 0 : _a.file) || ((_b = apiLogo === null || apiLogo === void 0 ? void 0 : apiLogo.file) === null || _b === void 0 ? void 0 : _b.url)) || this.file;
        this.hide = !!((_c = clientConfig.logo) === null || _c === void 0 ? void 0 : _c.hide) || !!(apiLogo === null || apiLogo === void 0 ? void 0 : apiLogo.hide);
        this.link = ((_d = clientConfig.logo) === null || _d === void 0 ? void 0 : _d.link) || (apiLogo === null || apiLogo === void 0 ? void 0 : apiLogo.link) || this.link;
        this.margin = (0, utilities_1.convertToNumber)(((_e = clientConfig.logo) === null || _e === void 0 ? void 0 : _e.margin) || (apiLogo === null || apiLogo === void 0 ? void 0 : apiLogo.margin), this.margin);
        this.width = ((_f = clientConfig.logo) === null || _f === void 0 ? void 0 : _f.width) || (apiLogo === null || apiLogo === void 0 ? void 0 : apiLogo.width) || this.width;
        this.position = ((_g = clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.logo) === null || _g === void 0 ? void 0 : _g.position) || (apiLogo === null || apiLogo === void 0 ? void 0 : apiLogo.position) || player_config_1.LogoPositions.TOP_RIGHT;
        var _j = this.position.split('-'), verticalPos = _j[0], horizontalPos = _j[1];
        this.style = "margin-".concat(verticalPos, ":").concat(this.margin, "px; margin-").concat(horizontalPos, ":").concat(this.margin, "px; width:").concat(this.width);
        this.classList = "jw-logo jw-logo-".concat(this.position, " jw-reset ").concat(this.hide ? 'jw-hide' : '');
        this.linkType = ((_h = clientConfig.logo) === null || _h === void 0 ? void 0 : _h.linkType) || (apiLogo === null || apiLogo === void 0 ? void 0 : apiLogo.linkType) || null;
        if (this.linkType === player_config_1.LinkType.KIJK) {
            this.link = "https://www.kijk.nl/video/".concat(clientConfig.playlist[0]);
        }
        if (this.linkType === player_config_1.LinkType.NO_LINK) {
            this.link = '';
        }
    }
    return Logo;
}());
exports.Logo = Logo;
